import _styled from "styled-components";
import React from "react";
import { ReactComponent as WarningIcon } from "@svgr/webpack?-svgo,+titleProp,+ref!@smartheat/common/svg/warning_triangle.svg";
import { useAlarms } from "../../../DeviceData/useAlarms";

var AlarmsContainer = _styled.div.withConfig({
  displayName: "Alarms__AlarmsContainer",
  componentId: "l0ftbf-0"
})(["display:flex;align-items:center;justify-content:center;"]);

var AlarmsBox = _styled.div.withConfig({
  displayName: "Alarms__AlarmsBox",
  componentId: "l0ftbf-1"
})(["background-color:#dd4e4e;border-radius:20px;padding:8px 16px;display:flex;gap:8px;align-items:center;svg{color:white;}"]);

var AlarmCode = _styled.span.withConfig({
  displayName: "Alarms__AlarmCode",
  componentId: "l0ftbf-2"
})(["color:white;font-size:24px;line-height:1;font-weight:bold;"]);

export function Alarms() {
  var alarms = useAlarms();
  if (alarms.length == 0) return null;
  return /*#__PURE__*/React.createElement(AlarmsContainer, null, /*#__PURE__*/React.createElement(AlarmsBox, null, /*#__PURE__*/React.createElement(WarningIcon, null), /*#__PURE__*/React.createElement(AlarmCode, null, alarms[0])));
}